import { Badge } from "@/components/ui/badge";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

import {
  MONETIZATION_EXPERIMENTS,
  type MonetizationExperiment,
} from "./monetizationExperiments";

export function MonetizationExperimentSelect({
  value,
  onChange,
}: {
  value: MonetizationExperiment;
  onChange: (experimentId: string) => void;
}) {
  return (
    <Select value={value.id} onValueChange={onChange}>
      <SelectTrigger size="sm" aria-label="Monetization read model">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {MONETIZATION_EXPERIMENTS.map((experiment) => (
          <SelectItem key={experiment.id} value={experiment.id}>
            <span className="flex items-center gap-2">
              {experiment.label}
              {experiment.live ? (
                <Badge variant="default" className="text-[10px]">
                  live
                </Badge>
              ) : null}
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
